<template>
    <div>
        <div v-if="loading" style="height: 300px;">
            <loading :active="loading" 
                :can-cancel="false" 
                :is-full-page="false">
            </loading>
        </div>

        <div v-else>
            <div v-if="vendor_data">
                <b-card-text>
                    <h5>
                        <span>SALE INVOICE #: </span>
                        <span>{{vendor_data.sale_invoice_id}} </span>
                    </h5>
                </b-card-text>

                <b-card-text>
                    <div class="label">SKU: </div>
                    <div class="value">{{vendor_data.product_sku}} ({{vendor_data.vendor}})</div>
                </b-card-text>

                <b-card-text>
                    <div class="label">QUANTITY: </div>
                    <div class="value">
                        <b-input size="sm" v-model="vendor_data.quantity" style="width: 50px; text-align: center;"></b-input>
                    </div>
                </b-card-text>

                <b-card-text>
                    <div class="label">VENDOR PO #: </div>
                    <div class="value">
                        <b-input size="sm" v-model="vendor_data.vendor_invoice_id" style="width: 250px;"></b-input>
                        <sub>Important: This is the po # / invoice id of the order made with vendor.</sub>
                    </div>
                </b-card-text>

                <b-card-text>
                    <div class="label">ORDER DATE: </div>
                    <div class="value">{{vendor_data.vendor_order_date}}</div>

                </b-card-text>

                <b-card-text>
                    <div class="label">ORDER STATUS</div>
                    <div class="value">
                        <b-form-select :options="vendor_order_statuses" v-model="vendor_data.vendor_order_status" style="width: 150px;" size="sm"></b-form-select>
                    </div>

                    <div v-if="vendor_data.vendor_order_status == 3 && !vendor_data.location_id">
                        <div>PICK A LOCATION TO ADD INVENTORY</div>
                        <b-form-select style="width: 250px; font-size: 10px;" v-model="vendor_data.locsub" :options="packet.locsubs"></b-form-select>
                    </div>

                </b-card-text>

                <b-card-text>
                    <div class="label">ORDER ETA</div>
                    <div class="value">
                        <!-- <flat-pickr  :config="{ dateFormat: 'm-d-Y', mode: 'single' }" style="padding: 8px; font-size: 11px; text-align: center; border: 1px solid gray; width: 100px;" v-model="vendor_data.eta"></flat-pickr> -->

                        <date-picker v-model="vendor_data.eta" format="MM-DD-YYYY" valueType="format"
                         style="font-size: 11px; text-align: center; border: 1px solid gray; width: 130px;" 
                        
                        ></date-picker>

                    </div>

                </b-card-text>

                <b-card-text>
                    <div class="label">ORDER TYPE</div>
                    <div class="value">{{vendor_order_types_dict[vendor_data.vendor_order_type]}}</div>

                </b-card-text>

                <b-card-text>
                    <div class="label">COMMENTS</div>
                    <div class="value">
                        <b-textarea rows="6" v-model="vendor_data.comment_txt">

                        </b-textarea>

                    </div>

                </b-card-text>

                <b-card-text style="text-align: right;">
                    <button @click="save">SAVE</button>
                </b-card-text>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Requestor from '@/utilities/Requestor'
    import moment from 'moment'
    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    export default {
        name: "VendorOrder",
        components: {Requestor,Loading,DatePicker},
        props: ["viewdata"],
        data: function(){
            return {
                edit: false,
                packet: {},
                vendor_data: {},
                loading: true,
                vendor_order_types: [
                    {value: 1, text: "BACKORDER"},
                    {value: 2, text: "SPECIAL ORDER"},
                ],
                vendor_order_types_dict: {
                    1: "BACKORDER",
                    2: "SPECIAL ORDER",
                },
                vendor_order_statuses: [
                    {value: 0, text: "OPEN"},
                    {value: 1, text: "ORDERED"},
                    {value: 2, text: "IN-TRANSIT"},
                    {value: 3, text: "RECEIVED"},
                    {value: 4, text: "DISCONTINUED"},
                ],
            }
        },
        methods: {
            save: function(e){
                if (e){
                    e.preventDefault();
                }

                let that = this;
                let path = "/api/sales/update_vendor_order/"
                let data = this.vendor_data;

                let quantity = parseInt(data.quantity);
                if (isNaN(quantity) || quantity <= 0){
                    this.$vex.dialog.alert({
                        message: "Please provide a valid non-zero quantity for the order."
                    });
                    return
                }
                data.quantity = quantity;

                if (data.locsub){
                    let splitted = data.locsub.split("|");
                    data.location_id = parseInt(splitted[0]);
                    data.sublocation_id = parseInt(splitted[1]);
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Successfully updated vendor order.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.loading = false
                    
                }
                let f =  function(error){
                    that.$bvToast.toast(
                        "Error updaing vendor order.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.loading = false;
                }
                this.loading = true;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_init: function(){
                let that = this;
                let prereqs = [
                    {
                        path: "/api/sales/get_vendor_order/",
                        data: {vendor_order_id: this.vendor_data.vendor_order_id},
                        s: function(response){
                            if (response.data.error){
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            else {
                                that.vendor_data = response.data.result[0];

                                if (that.vendor_data.location_id){
                                    that.vendor_data.locsub = that.vendor_data.location_id+'|'+that.vendor_data.sublocation_id;
                                }
                            }
                            that.loading = false
                            
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading vendor order.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            that.loading = false;
                        },
                        type: "",
                        executable: Requestor.getAsync
                    }
                ];

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        console.log("e")
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            }
        },
        mounted: function(){
            this.vendor_data = JSON.parse(JSON.stringify(this.viewdata.vendor_order));
            this.packet = this.viewdata.packet;
            this.loading = true;
            this.fetch_init()
        }
    }
</script>

<style scoped>

    .label {
        font-size: 13px;
        padding: 3px;
        background: lightgray;
    }

    .value {
        font-size: 13px;
        padding: 3px;
        background: beige;
    }

</style>


// WEBPACK FOOTER //
// src/components/importables/VendorOrder.vue